import { render, staticRenderFns } from "./SupplierAddresses.vue?vue&type=template&id=3e0ec0f8&scoped=true&"
import script from "./SupplierAddresses.vue?vue&type=script&lang=ts&"
export * from "./SupplierAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ec0f8",
  null
  
)

export default component.exports